import {Component, Input, OnInit} from '@angular/core';
import {NzMessageService} from 'ng-zorro-antd/message';
import {TaskService} from '../../../../services/task.service';
import {TableViewAbstractComponent} from '../../table-view-abstract/table-view-abstract.component';
@Component({
  selector: 'app-table-column-text',
  templateUrl: './table-column-text.component.html',
  styleUrls: ['../../../../views/new-table/new-table.component.css']
})
export class TableColumnTextComponent extends TableViewAbstractComponent implements OnInit {
  constructor(
    private taskHttpService: TaskService,
    private nzMessageService: NzMessageService
  ) {
    super(nzMessageService, taskHttpService);
  }

  ngOnInit(): void {
  }
}
